import { useMemo } from 'react';
import { useHistory } from 'react-router';

import useConfirmationDialog from '../../commons/dialog/useConfirmationDialog';
import { useUserStore } from '../../store/models';
import { isFreeTrial } from '../../utils';

// Shared "Upgrade ECAL Plan" gate for features that aren't available to Free Trial publishers.
function useUpgradeEcalPlanDialog () {
    const history = useHistory();
    const userStore = useUserStore();

    const { renderDialog, openDialog } = useConfirmationDialog({
        title: 'Upgrade ECAL Plan',
        message: 'This feature is not available on your current ECAL plan. Please go to billing section to upgrade your ECAL plan.',
        confirmLabel: 'Go to upgrade',
        cancelLabel: 'Cancel',
        onConfirm: () => { history.push('/admin/settings/billing'); },
        onClose: () => {},
    });

    // Keyed on the observed token so the calling observer() re-renders when the publisher changes.
    const isFreeTrialPlan = useMemo(
        () => isFreeTrial(userStore.publisher?.planName || ''),
        [userStore.observed.publisher],
    );

    return {
        isFreeTrialPlan,
        openUpgradeDialog: openDialog,
        renderUpgradeDialog: renderDialog,
    };
}

export default useUpgradeEcalPlanDialog;
